import React, { useState, useEffect } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { urunUrl, YuklenenLogoUrl } from '../Utils';
import Product from './Product';
import { useTranslation } from 'react-i18next';
import { IoStorefront } from 'react-icons/io5';
import { MdDeliveryDining } from 'react-icons/md';
import ServiceModePopup from './ServiceModePopup';
import { useServiceMode } from '../helpers/UseServiceMode';

function CategoryCard({ category, companyLogo, setKey, companyColor }) {
  const handleClick = () => {
    setKey(category.Id);
  };

  const primarySrc = category?.Resim ? `${urunUrl}kucukresimler/${category.Resim}` : null;

  const fallbackSrc = companyLogo ? `${YuklenenLogoUrl}${companyLogo}` : `${YuklenenLogoUrl}`;


  return (
    <div onClick={handleClick}>
      <div className="category-card" >
        <img
          src={primarySrc || fallbackSrc}
          alt={category?.Adi || "Kategori"}
          className="category-image"
          onError={(e) => {
            if (e.currentTarget.src !== fallbackSrc) {
              e.currentTarget.onerror = null;
              e.currentTarget.src = fallbackSrc;
            }
          }}
        />
        <div className="category-overlay">
          <span className="category-title">{category.Adi}</span>
          <span className="category-icon" style={{ ["--category-icon-accent"]: companyColor }}>
            <FaArrowRight />
          </span>
        </div>
      </div>
      <span className="category-title-mobile">{category.Adi}</span>
    </div>
  );
}

export default function MenuCategories({ categories, products, currencySymbol, companyLogo, companyColor, companyServiceModeState }) {
  const { t } = useTranslation("translation", { keyPrefix: "menuCategories" });

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [currencyTourSymbol, setCurrencyTourSymbol] = useState(currencySymbol);
  const [serviceModePopup, setServiceModePopup] = useState(false);
  const mode = useServiceMode();

  useEffect(() => {
    setCurrencyTourSymbol(currencySymbol);
  }, [currencySymbol]);

  const handleCategoryClick = (categoryId) => {
    setSelectedCategoryId(categoryId);
  };

  const handleBack = () => {
    setSelectedCategoryId(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      {selectedCategoryId === null ? (
        <section className="category-section">
          <h2 className="category-title-main">{t("categorys")}</h2>
          <p className="category-subtitle">
            {t("categorysTitle")}
          </p>
          <div class="smp-minimal" style={{ ["--smp-accent"]: companyColor, display: companyServiceModeState ? 'block' : 'none'}}>
            <div class="smp-minimal-group segmented">
              <button className={`smp-minimal-btn ${mode === "pickup" ? "is-selected" : ""}`} onClick={() => setServiceModePopup(true)}>
                <span class="smp-minimal-icon"><IoStorefront size={30} color={mode === "pickup" ? "white" : companyColor} /></span>
              </button>
              <button className={`smp-minimal-btn ${mode === "delivery" ? "is-selected" : ""}`} onClick={() => setServiceModePopup(true)}>
                <span class="smp-minimal-icon"><MdDeliveryDining size={30} color={mode === "delivery" ? "white" : companyColor} /></span>
              </button>
            </div>
          </div>
          <div className="category-grid">
            {categories.map(category => (
              <CategoryCard
                key={category.Id}
                category={category}
                setKey={handleCategoryClick}
                companyLogo={companyLogo}
                companyColor={companyColor}
              />
            ))}
          </div>
        </section>
      ) : (
        <div >
          <div className="category-back-button-wrapper" style={{ ["--back-btn-accent"]: companyColor }}>
            <button className="category-back-button" onClick={handleBack}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span> {t("backCategories")}</span>
            </button>
            <div class="smp-minimal" style={{ ["--smp-accent"]: companyColor, display: companyServiceModeState ? 'block' : 'none' }}>
              <div class="smp-minimal-group segmented">
                <button className={`smp-minimal-btn ${mode === "pickup" ? "is-selected" : ""}`} onClick={() => setServiceModePopup(true)}>
                  <span class="smp-minimal-icon"><IoStorefront size={30} color={mode === "pickup" ? "white" : companyColor} /></span>
                </button>
                <button className={`smp-minimal-btn ${mode === "delivery" ? "is-selected" : ""}`} onClick={() => setServiceModePopup(true)}>
                  <span class="smp-minimal-icon"><MdDeliveryDining size={30} color={mode === "delivery" ? "white" : companyColor} /></span>
                </button>
              </div>
            </div>
          </div>
          <Product
            visible={true}
            categories={categories}
            products={products}
            currencySymbol={currencyTourSymbol}
            initialKey={selectedCategoryId}
            companyLogo={companyLogo}
            companyColor={companyColor}
            companyServiceModeState={companyServiceModeState}
          />
        </div>
      )}
      <ServiceModePopup
        isOpen={serviceModePopup}
        onClose={() => setServiceModePopup(false)}
        accentColor={companyColor}
      />
    </div>
  );
}
